module.exports = __webpack_public_path__ + "static/media/1_pl.4dec9dcf.png";